/* eslint-disable react/jsx-props-no-spreading */

import React from "react";
import { useAppContext } from "./hooks/useAppContext";
import { Navigate } from "react-router-dom";

export default function CheckoutRoute({ children }) {
  const { isCheckoutEnabled, shouldGoThankYou } = useAppContext();
  if (!isCheckoutEnabled) {
    return (
      <Navigate
        to={{ pathname: "/give/checkout", search: location.search }}
        replace
      />
    );
  }

  if (shouldGoThankYou) {
    return <Navigate to="/give/thank-you" replace/>;
  }

  return children;
}
